/** Дольше не держим: медленная сеть не должна вешать загрузку на «95%». */
const PRELOAD_MAX_MS = 6000

/**
 * Дождаться, пока браузер скачает картинку по только что выданному адресу. Без
 * этого после «Загружаю… 100%» место на секунду пустело: адрес уже записан, а
 * сама картинка ещё едет с CDN. Ошибку и таймаут не бросаем — это лишь косметика,
 * картинка всё равно покажется, когда доедет.
 */
export const preloadImage = (url: string): Promise<void> => {
  // В jsdom картинки не грузятся вовсе — `load` не придёт, тесты ждали бы таймаут.
  if (import.meta.env.MODE === 'test' || typeof Image === 'undefined') return Promise.resolve()
  return new Promise((resolve) => {
    const img = new Image()
    const done = () => {
      window.clearTimeout(timer)
      resolve()
    }
    const timer = window.setTimeout(done, PRELOAD_MAX_MS)
    img.onload = done
    img.onerror = done
    img.src = url
  })
}
